// extracted by mini-css-extract-plugin
module.exports = {"moreDetails":"styles__moreDetails___3w6xO","modelContent":"styles__modelContent___174tv","label":"styles__label___1fXcr","detailContent":"styles__detailContent___t5cVy"};